<template>
  <div>
    <template v-if="userInfo&&userInfo.freeOrder === true">
      <gj-area-title style="margin: 0">订单扣减说明</gj-area-title>
      <div style="padding: 20px 0 40px 20px;color: #999;">
        新店孵化大礼包，限时免费送—每日订单量小于100单的店铺免扣订单量
      </div>
    </template>

    <gj-area-title style="margin: 0">套餐剩余额度</gj-area-title>
    <el-row>
      <el-col :span="6">
        <div class="chart-title">
          <span class="chart-icon"><img src="./img/orders.png" /></span>
          订单量</div>
        <div class="chartLegend">
          <div style="text-align: center; color: #444">剩余<span class="chartLegend-color"> {{packageQuotaInfo.remainingOrder}} </span>单</div>
          <div class="chartLegend-label">有效期至 {{packageQuotaInfo.expirationDate}}</div>
        </div>
        <div ref="chart1" style="width: 100%; height: 260px"></div>
      </el-col>
      <el-col :span="6">
        <div class="chart-title">
          <span class="chart-icon"><img src="./img/keyword-monitor.png" /></span>
          关键词监控</div>
        <div class="chartLegend">
          <div style="text-align: center; color: #444">剩余<span class="chartLegend-color"> {{packageQuotaInfo.remainingKeywordsMonitor}} </span>个</div>
          <div class="chartLegend-label">有效期至 {{packageQuotaInfo.expirationDate}}</div>
        </div>
        <div ref="chart2" style="width: 100%; height: 260px"></div>
      </el-col>
      <el-col :span="6">
        <div class="chart-title">
          <span class="chart-icon"><img src="./img/offer-monitor.png" /></span>
          跟卖监控</div>
        <div class="chartLegend">
          <div style="text-align: center; color: #444">剩余<span class="chartLegend-color"> {{packageQuotaInfo.remainingFollowUpMonitor}} </span>个</div>
          <div class="chartLegend-label">有效期至 {{packageQuotaInfo.expirationDate}}</div>
        </div>
        <div ref="chart3" style="width: 100%; height: 260px"></div>
      </el-col>
      <el-col :span="6">
        <div class="chart-title">
          <span class="chart-icon"><img src="./img/offer-monitor.png" /></span>
          关怀邮件</div>
        <div class="chartLegend">
          <div style="text-align: center; color: #444">剩余<span class="chartLegend-color"> {{packageQuotaInfo.remainingEmailNumber}} </span>件</div>
          <div class="chartLegend-label">有效期至 {{packageQuotaInfo.expirationDate}}</div>
        </div>
        <div ref="chart4" style="width: 100%; height: 260px"></div>
      </el-col>
    </el-row>

    <gj-area-title>订单包充值流水</gj-area-title>
    <div class="order-recharge">
      <gj-table
          :adapt-height="false"
          :index="false"
          border
          :data="tableData"
          :columns="columns"
          :height="400"
          :is-min-height="false"
          :default-sort="{prop: 'rechargeTime', order: 'descending'}"
      ></gj-table>
    </div>

    <gj-area-title style="margin-top:15px">加油包充值流水</gj-area-title>
    <div class="order-recharge">
      <gj-table
          :adapt-height="false"
          :index="false"
          border
          :data="tableDataMail"
          :columns="columnsMail"
          :height="400"
          :is-min-height="false"
          :default-sort="{prop: 'rechargeTime', order: 'descending'}"
      ></gj-table>
    </div>
  </div>
</template>

<script>
  import {getOrdersFlow, getPackageQuota} from "../../../../api/personal-center";
  import {mapGetters} from "vuex";

  const flowTypeOption = [
    {id: 'Handsel', text: '赠送'},
    {id: 'Buy', text: '购买'},
  ];
  export default {
    name: "personal-center-setMeal",
    computed:{
      ...mapGetters(['userInfo'])
    },
    mounted() {
      getPackageQuota()
        .then((result) => {
          this.packageQuotaInfo = result;
          this.chartOption1.series[0].data.push(...[
            {
              value: this.packageQuotaInfo.useOrder>0?this.packageQuotaInfo.useOrder:0,
              name: '已使用订单量'
            },
            {
              value: this.packageQuotaInfo.remainingOrder>0?this.packageQuotaInfo.remainingOrder:0,
              name: '剩余订单量'
            }
          ]);
          this.chartOption2.series[0].data.push(...[
            {
              value: this.packageQuotaInfo.useKeywordsMonitor>0?this.packageQuotaInfo.useKeywordsMonitor:0,
              name: '已使用关键词监控'
            },
            {
              value: this.packageQuotaInfo.remainingKeywordsMonitor>0?this.packageQuotaInfo.remainingKeywordsMonitor:0,
              name: '剩余关键词监控'
            }
          ]);
          this.chartOption3.series[0].data.push(...[
            {
              value: this.packageQuotaInfo.useFollowUpMonitor>0?this.packageQuotaInfo.useFollowUpMonitor:0,
              name: '已使用监控量'
            },

            {value: this.packageQuotaInfo.remainingFollowUpMonitor>0?this.packageQuotaInfo.remainingFollowUpMonitor:0,
              name: '剩余监控量'
            }
          ]);
          this.chartOption4.series[0].data.push(...[
            {
              value: this.packageQuotaInfo.useEmailNumber>0?this.packageQuotaInfo.useEmailNumber:0,
              name: '已使用邮件数量'
            },

            {value: this.packageQuotaInfo.remainingEmailNumber>0?this.packageQuotaInfo.remainingEmailNumber:0,
              name: '剩余邮件数量 '
            }
          ]);
          this.renderChart1();
          this.renderChart2();
          this.renderChart3();
          this.renderChart4();
        });
      getOrdersFlow().then((result) => {
        this.tableData = result.orderPayFlowDetails;
        this.tableDataMail = result.fuelPacPayFlowDetails;
      })
    },
    data() {
      return {
        packageQuotaInfo: {
          useOrder: null,
          remainingOrder: null,
          useKeywordsMonitor: null,
          remainingKeywordsMonitor: null,
          useFollowUpMonitor: null,
          remainingFollowUpMonitor: null,
          expirationDate: null
        },
        chart1: null,
        chartOption1: {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            show: false,
            orient: 'vertical',
            left: 10,
            data: ['已使用订单量', '剩余订单量']
          },
          series: [
            {
              name: '订单量',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
              },
              emphasis: {
                label: {
                  show: false,
                }
              },
              labelLine: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    //自定义颜色
                    let colorList = ['#f5222d', '#1F6EEF'];
                    return colorList[params.dataIndex]
                  }
                }
              },
              data: []
            }
          ]
        },
        chart2: null,
        chartOption2: {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            show: false,
            orient: 'vertical',
            left: 10,
            data: ['已使用关键词监控', '剩余关键词监控']
          },
          series: [
            {
              name: '关键词监控',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
              },
              emphasis: {
                label: {
                  show: false,
                }
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    //自定义颜色
                    let colorList = ['#f5222d', '#1F6EEF'];
                    return colorList[params.dataIndex]
                  }
                }
              },
              labelLine: {
                show: false
              },
              data: []
            }
          ]
        },
        chart3: null,
        chartOption3: {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            show: false,
            orient: 'vertical',
            left: 10,
            data: ['已使用监控量', '剩余监控量']
          },
          series: [
            {
              name: '跟卖监控',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
              },
              emphasis: {
                label: {
                  show: false,
                }
              },
              labelLine: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    //自定义颜色
                    let colorList = ['#f5222d', '#1F6EEF'];
                    return colorList[params.dataIndex]
                  }
                }
              },
              data: []
            }
          ]
        },
        chart4: null,
        chartOption4: {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            show: false,
            orient: 'vertical',
            left: 10,
            data: ['已使用邮件数量', '剩余邮件数量']
          },
          series: [
            {
              name: '关怀邮件',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
              },
              emphasis: {
                label: {
                  show: false,
                }
              },
              labelLine: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    //自定义颜色
                    let colorList = ['#f5222d', '#1F6EEF'];
                    return colorList[params.dataIndex]
                  }
                }
              },
              data: []
            }
          ]
        },
        tableData: [],
        tableDataMail:[],
        columns: [
          {id: 'payDate', header: '充值时间', field: 'payDate', minWidth: '120px'},
          {id: 'quantityBeforePay', header: '充值前数量', field: 'quantityBeforePay', minWidth: '120px', align: 'right'},
          {id: 'quantityAfterPay', header: '充值后数量', field: 'quantityAfterPay', minWidth: '120px', align: 'right'},
          {id: 'type', header: '类型', field: 'option:type', minWidth: '120px', options: flowTypeOption},
          {id: 'userName', header: '操作者', field: 'userName', minWidth: '120px'},
          {id: 'validPeriod', header: '有效期', field: 'validPeriod', minWidth: '180px'}
        ],
        columnsMail:[
          {id: 'packageType', header: '加油包类型', field: 'packageType', minWidth: '120px'},
          {id: 'payDate', header: '充值时间', field: 'payDate', minWidth: '120px'},
          {id: 'quantityBeforePay', header: '充值前数量', field: 'quantityBeforePay', minWidth: '120px', align: 'right'},
          {id: 'quantityAfterPay', header: '充值后数量', field: 'quantityAfterPay', minWidth: '120px', align: 'right'},
          {id: 'type', header: '类型', field: 'option:type', minWidth: '120px', options: flowTypeOption},
          {id: 'userName', header: '操作者', field: 'userName', minWidth: '120px'}
        ]
      }
    },
    methods: {
      renderChart1() {
        const ref = this.$refs.chart1;
        if (ref) {
          if (!this.chart1) {
            this.chart1 = this.$echarts.init(ref);
            this.chart1.setOption(this.chartOption1);
            window.addEventListener("resize", () => {
              this.chart1.resize()
            });
            this.$on('hook:destroyed', () => {
              window.removeEventListener("resize", () => {
                this.chart1.resize();
              });
            });
          } else {
            this.chart1.setOption(this.chartOption1, true);
          }
        }
      },
      renderChart2() {
        const ref = this.$refs.chart2;
        if (ref) {
          if (!this.chart2) {
            this.chart2 = this.$echarts.init(ref);
            this.chart2.setOption(this.chartOption2);
            window.addEventListener("resize", () => {
              this.chart2.resize()
            });
            this.$on('hook:destroyed', () => {
              window.removeEventListener("resize", () => {
                this.chart2.resize();
              });
            });
          } else {
            this.chart2.setOption(this.chartOption2, true);
          }
        }
      },
      renderChart3() {
        const ref = this.$refs.chart3;
        if (ref) {
          if (!this.chart3) {
            this.chart3 = this.$echarts.init(ref);
            this.chart3.setOption(this.chartOption3);
            window.addEventListener("resize", () => {
              this.chart3.resize()
            });
            this.$on('hook:destroyed', () => {
              window.removeEventListener("resize", () => {
                this.chart3.resize();
              });
            });
          } else {
            this.chart3.setOption(this.chartOption3, true);
          }
        }
      },
      renderChart4() {
        const ref = this.$refs.chart4;
        if (ref) {
          if (!this.chart4) {
            this.chart4 = this.$echarts.init(ref);
            this.chart4.setOption(this.chartOption4);
            window.addEventListener("resize", () => {
              this.chart4.resize()
            });
            this.$on('hook:destroyed', () => {
              window.removeEventListener("resize", () => {
                this.chart4.resize();
              });
            });
          } else {
            this.chart4.setOption(this.chartOption4, true);
          }
        }
      },
    }
  }
</script>

<style scoped>
  .chartLegend {
    position: relative;
    top: 145px;
    text-align: center;
  }

  .chartLegend-label {
    color: #888;
    font-size: 12px;
  }

  .chart-title {
    color: #888;
    position: relative;
    top: 40px;
    text-align: center;
    font-size: 16px;
  }

  .order-recharge {
    padding: 0 12px;
  }

  .chartLegend-color {
    color: red;
  }
  .chart-icon {
    position: relative;
    top: 5px;
    left: -6px;
  }
</style>
